// store/confirmationStore.ts
import { create } from 'zustand';

type ConfirmationDialog = {
    title: string;
    message: string;
    confirmLabel?: string;
    cancelLabel?: string;
    onConfirm?: () => void;
    onCancel?: () => void;
    open: boolean;
};

type ConfirmationStore = {
    dialog: ConfirmationDialog | null;
    showConfirmation: (
        title: string,
        message: string,
        onConfirm?: () => void,
        onCancel?: () => void,
        confirmLabel?: string,
        cancelLabel?: string
    ) => void;
    hideConfirmation: () => void;
};

const useConfirmationStore = create<ConfirmationStore>((set) => ({
    dialog: null,

    showConfirmation: (title, message, onConfirm, onCancel, confirmLabel = 'Confirm', cancelLabel = 'Cancel') =>
        set({
            dialog: {
                title,
                message,
                confirmLabel,
                cancelLabel,
                onConfirm,
                onCancel,
                open: true,
            },
        }),

    hideConfirmation: () => set({ dialog: null }),
}));

export default useConfirmationStore;
